import { Config } from "../../configurations/config";
export const Project_APIs = {
	GetAllProjects_API: `${Config.server_url}${Config.api_prefix}/Project/GetAllProjects?PageNumber=`,
	GetProjectType_API: `${Config.server_url}${Config.api_prefix}/Project/GetProjectTypeList`,
	GetAllEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetAllEmployeesWithCode_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployeesWithCode`,
	GetSupervisors_API: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsList`,
	CreateProject_API: `${Config.server_url}${Config.api_prefix}/Project/CreateProject`,
	GetProjectDetails_API: `${Config.server_url}${Config.api_prefix}/Project`,
	EditProject_API: `${Config.server_url}${Config.api_prefix}/Project/EditProject`,
	ToggleActiveInactive_API: `${Config.server_url}${Config.api_prefix}/Project/ChangeProjectStatus`,
	ProjectHistory_API: `${Config.server_url}${Config.api_prefix}/Project/GetAllProjectHistory?projectID=`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/Project/GetAllProjects/ExportToExcel`,
};
